import { Alert, Button } from 'react-bootstrap';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

/**
 * Router-level error UI (React Router's `errorElement`). Catches errors thrown
 * outside the component tree wrapped by <ErrorBoundary> — e.g. a failed lazy
 * chunk load or an error thrown while matching/rendering a route's element.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred.';

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    message = error.data?.message ?? message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  console.error('Unhandled routing error:', error);

  return (
    <Alert variant="danger" className="m-4">
      <Alert.Heading>{title}</Alert.Heading>
      <p>{message}</p>
      <Button variant="outline-danger" onClick={() => window.location.reload()}>
        Reload page
      </Button>
    </Alert>
  );
}
